import { useEffect, useRef } from 'react';
import { NavigationType, useLocation, useNavigationType } from 'react-router';

import { useIsFirstRenderRef } from 'hooks/useIsFirstRenderRef';
import { useIsInEmbedSearchWidget } from 'modules/embedSearchWidget/hooks/useIsInEmbedSearchWidget';
import { postEmbedSearchWidgetMessage } from 'modules/embedSearchWidget/utils/postEmbedSearchWidgetMessage';
import { trackEvent } from 'utils/analytics/track/trackEvent';

type RenderingClientLocationHooksLocationState = {
  suppressScrollReset?: boolean;
};

export function RenderingClientLocationHooks() {
  const location = useLocation<RenderingClientLocationHooksLocationState>();

  const { suppressScrollReset } = location.state || {};
  const navType = useNavigationType();
  const hasMounted = useRef(false);

  const { isInEmbedSearchWidget } = useIsInEmbedSearchWidget();
  const { isFirstRenderRef } = useIsFirstRenderRef();

  useEffect(() => {
    if (isInEmbedSearchWidget) {
      if (!isFirstRenderRef.current) {
        postEmbedSearchWidgetMessage({ type: 'idealist-scroll-top' });
      }

      return;
    }

    if (!suppressScrollReset) {
      window.scrollTo(0, 0);
    }
  }, [
    isFirstRenderRef,
    isInEmbedSearchWidget,
    location.pathname,
    suppressScrollReset,
  ]);

  useEffect(() => {
    if (hasMounted.current) {
      if (navType !== NavigationType.Replace) {
        trackEvent('JS Page View');
      }
    } else {
      hasMounted.current = true;
    }
  }, [location, navType]);

  return null;
}
